import React from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import cookie from 'react-cookies';
import { fetchUserwiseData } from './../../service/action/audio-track-action';
import Header from '../../Components/Header/Header';
import Card from '../Dashboard/Card';
import '../../assets/vendors/style';
//import ReactDOM from "react-dom";
//import PropTypes from 'prop-types'

class DashBoard extends React.Component {
  componentWillMount() {
    this.props.fetchUserwiseData(cookie.load('username'));
    // this.props.fetchTrainedCountReport(0, 10);
    // this.props.fetchTranscriptedReport(0, 10);
    // this.props.fetchComparedStatisticReport();
    // console.log(this.props)
  }

  render() {
    console.log(this.props.AudioToTrackReducer);
    return (
      <div>
        <div className='CK-pages'>
          <div className='right-section'>
            <div className=''>
              <Header page='Dashboard' />
              <div style={{ padding: 50 }} className='container-fluid'>
                <div className='row'>
                  <div className='col-lg-12'>
                    {Object.entries(
                      this.props.AudioToTrackReducer.UserDashboard
                    ).map((postData) => {
                      return (
                        <Card
                          key={postData[1].ReportHeade}
                          Header={postData[1].ReportHeader}
                          FTD={postData[1].FTD}
                          MTD={postData[1].MTD}
                          Allocated={postData[1].Allocated}
                          Pending={postData[1].Pending}
                        />
                      );
                    })}
                    {/* <div className='col-lg-3 col-sm-6 col-12'>
                        <div className='card jr-card-intra shadow text-center'>
                          <div className='card-header py-3 d-flex align-items-center'>
                            <h3 className='mb-0'>Header</h3>
                            <span className='badge badge-secondary ml-auto'>
                              Monthly
                            </span>
                          </div>
                          <div className='stack-order  py-4 px-2'>
                            <h1 className='chart-f30'>386,200</h1>
                            <span className='h3 text-muted'>100</span>
                            <span className='h5 text-green'>
                              <i className='zmdi zmdi-flash zmdi-hc-fw' />
                              98%
                            </span>
                          </div>
                        </div>
                      </div> */}
                    {/* <div className='col-lg-3 col-sm-6 col-12'>
                        <div className='card jr-card-intra shadow text-center'>
                          <div className='card-header py-3 d-flex align-items-center'>
                            <h3 className='mb-0'> orders </h3>
                            <span className='badge badge-secondary ml-auto'>
                              annual
                            </span>
                          </div>
                          <div className='stack-order py-4 px-2'>
                            <h1 className='chart-f30'>80,800</h1>
                            <span className='h3 text-muted'>newOrder</span>
                            <span className='h5 text-cyan'>
                              <i className='zmdi zmdi-long-arrow-return zmdi-hc-fw zmdi-hc-rotate-90' />
                              20%
                            </span>
                          </div>
                        </div>
                      </div> */}
                  </div>
                </div>
              </div>
              {/* <div style={{ padding: 100 }}>
                <Grid container direction='row' spacing={6}>
                  {Object.entries(
                    this.props.AudioToTrackReducer.UserDashboard
                  ).map((postData) => {
                    return (
                      <Grid item sm>
                        <Card
                          key={postData[1].ReportHeade}
                          Header={postData[1].ReportHeader}
                          FTD={postData[1].FTD}
                          MTD={postData[1].MTD}
                        />
                      </Grid>
                    );
                  })}
                </Grid>
              </div> */}
              {/* {this.props.AudioToTrackReducer.UserDashboard.map((key, val) => {
            console.log(val);
          })} */}
              {/* <Table name="Trained Sentence Count Report" data= {trainedSentenceCount}/> */}
              {/* <SimpleTable name="Trained Sentence Count Report" data= {compareStatsCount} /> */}
              {/* <Table data ={transcriptedSentenceCount}/>
                    <Table data ={compareStatsCount}/> */}
            </div>
          </div>
        </div>
      </div>
    );
  }
}

const mapStateToProps = (state) => {
  const { adminDashBoard, userLogin, page, AudioToTrackReducer } = state;
  return {
    adminDashBoard,
    userLogin,
    page,
    AudioToTrackReducer,
  };
};

const mapDispatchToProps = (dispatch) => ({
  fetchUserwiseData: (userId) => dispatch(fetchUserwiseData(userId)),
  //   fetchTrainedCountReport: (startPage, endPage) =>
  //     dispatch(fetchTrainedCountReport(startPage, endPage)),
  //   fetchTranscriptedReport: (startPage, endPage) =>
  //     dispatch(fetchTranscriptedReport(startPage, endPage)),
  //   fetchComparedStatisticReport: () => dispatch(fetchComparedStatisticReport()),
});

export default withRouter(
  connect(mapStateToProps, mapDispatchToProps)(DashBoard)
);
